module.exports = __webpack_public_path__ + "img/microplastics-process-8.6952efee.png";